export class RelativeUrlsProvider {
  static ManageAccountPageUrl = '/settings/account';
}
